import { render, staticRenderFns } from "./ciic-img-upload.vue?vue&type=template&id=d9dacd0a&"
import script from "./ciic-img-upload.vue?vue&type=script&lang=js&"
export * from "./ciic-img-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports